import React from 'react'
import classNames from 'classnames'

import Markdown from '@components/markdown'
import styles from '@components/blocks/callout_block.module.scss'
import ImageAsset from '@components/image_asset'

const CalloutBlock = React.forwardRef(
  (
    {
      fields: {
        backgroundColor,
        bottomRightImage,
        content,
        contentTextAlignment,
        spacing,
        title,
        topLeftImage,
      },
    },
    _
  ) => {
    const backgroundColorClass = (color => {
      switch (color) {
        case 'Purple':
          return styles['calloutBlock--purple']
        case 'Red':
          return styles['calloutBlock--red']
        case 'Teal':
          return styles['calloutBlock--teal']
        default:
          return null
      }
    })(backgroundColor)

    const spacingClass = (spacing => {
      switch (spacing) {
        case 'Large':
          return styles['calloutBlock--largeSpacing']
        default:
          return null
      }
    })(spacing)

    const contentTextAlignmentClass = (alignment => {
      switch (alignment) {
        case 'Left':
          return styles['calloutBlock__content--leftTextAlignment']
        default:
          return null
      }
    })(contentTextAlignment)

    return (
      <div className={classNames(styles.calloutBlock, backgroundColorClass, spacingClass)}>
        <div className={styles.calloutBlock__contentContainer}>
          <div className={styles.calloutBlock__title}>{title}</div>
          <Markdown className={classNames(styles.calloutBlock__content, contentTextAlignmentClass)}>
            {content}
          </Markdown>
          <ImageAsset
            asset={topLeftImage}
            className={styles.calloutBlock__topLeftImage}
            aria-hidden
          />
          <ImageAsset
            asset={bottomRightImage}
            className={styles.calloutBlock__bottomRightImage}
            aria-hidden
          />
        </div>
      </div>
    )
  }
)

export default CalloutBlock
